import React from "react";
import "./Home.css";
import "animate.css";
import Typewriter from "typewriter-effect";
import { motion } from "framer-motion";
import Scene from "./Scene";

function Home() {
  return (
    <div className="relative home" id="home">
      <div className="title">
        <h1 className="greet">
          <Typewriter
            onInit={(typewriter) => {
              typewriter.typeString("Hi, my name is").start().pauseFor(50000);
            }}
            options={{
              loop: true,
            }}
          />
        </h1>
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9 }}
          className="name"
        >
          Abhishek Vishwakarma
        </motion.h2>
        <motion.h3
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.7 }}
          transition={{ duration: 0.9, delay: 0.4 }}
          className="tag"
        >
          I build things for Web.
        </motion.h3>
        <p className="brief overflow-hidden">
          <motion.p
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeIn" }}
          >
            I'm a software engineer specialize in building and designing digital
            experiences. Currently, i'm into blending art of design with skill
            of programming to deliver engaging user experience, responsive,
            accesible and human friendly web-apps.
          </motion.p>
        </p>
      </div>
      {/* <Scene /> */}
    </div>
  );
}

export default Home;
